import mixpanel from 'mixpanel-browser';
import { AnyAction } from 'redux';

let isInitialized = false;

export const analyticsMiddleware =
  () => (next: Function) => (action: AnyAction) => {
    next(action);
    try {
      if (action.meta) {
        if (action.meta.initialize && !isInitialized) {
          mixpanel.init(action.meta.initialize, {
            batch_requests: true,
            api_host: process.env.REACT_APP_MIXPANEL_PROXY_DOMAIN,
            persistence: 'localStorage',
            ignore_dnt: true,
          });
          isInitialized = true;
          // if (mixpanel.has_opted_out_tracking()) mixpanel.opt_out_tracking();
        }

        if (action.meta.register) mixpanel.register(action.meta.register);

        if (action.meta.identify) {
          mixpanel.identify(action.meta.identify);
          mixpanel.people.set({
            $email: action.meta.identify,
          });
        }

        if (action.meta.track) {
          if (action.meta.includeData)
            mixpanel.track(action.type, { properties: action.payload });
          else mixpanel.track(action.type, undefined);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
